import { lazy } from 'react';

export * from './MTMapBox.component';
import type { MTMapBoxProps } from './MTMapBox.types';

const MTMapBox = lazy(() => import('./MTMapBox.component'));

export default MTMapBox;
export type { MTMapBoxProps };
